import { PencilIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import trackEvents from '../../constants/track-events'
import { classNames } from '../../helpers'
import { trackEvent } from '../../helpers/analytics'
import InputFormik from '../input-formik'

const DD_TEXT = 'mt-1 text-base font-medium text-gray-900'

const SpaceDetailItem = ({
  icon: Icon,
  term,
  details = '',
  onClick,
  input
}) => {
  const { t } = useTranslation()

  return (
    <div
      onClick={onClick}
      className={classNames('sm:col-span-1', onClick && 'group cursor-pointer')}
    >
      <dt className='flex items-center gap-1.5 text-sm text-gray-500'>
        {Icon && <Icon className='size-4 flex-shrink-0 text-primaryBlue' />}
        {term}
      </dt>
      {input ? (
        <>
          {input.formik.status[input.id] ? (
            <form
              onBlur={input.formik.resetForm}
              onSubmit={input.formik.handleSubmit}
            >
              <InputFormik ref={(ref) => ref && ref.focus()} {...input} />
            </form>
          ) : (
            <button
              className={classNames(
                'group flex items-center text-left hover:text-primaryBlue',
                DD_TEXT
              )}
              onClick={() => {
                trackEvent(trackEvents.EDIT_SPACE_PERSON)
                input.formik.setStatus({ [input.id]: true })
              }}
            >
              {details && <span>{details}</span>}
              {!details && (
                <span className='text-sm font-normal italic'>
                  {t('pages.talent.input_empty_action')}
                </span>
              )}
              <PencilIcon
                className={classNames(
                  'ml-1 hidden h-3 w-auto',
                  details && 'group-hover:inline-block'
                )}
              />
            </button>
          )}
        </>
      ) : (
        <dd
          title={typeof details === 'string' ? details : ''}
          className={classNames(
            'truncate group-hover:text-primaryBlue',
            DD_TEXT
          )}
        >
          {details}
        </dd>
      )}
    </div>
  )
}

SpaceDetailItem.propTypes = {
  icon: PropTypes.elementType,
  term: PropTypes.string.isRequired,
  details: PropTypes.any,
  onClick: PropTypes.func,
  input: PropTypes.object
}

SpaceDetailItem.defaultProps = {
  icon: undefined,
  onClick: undefined,
  input: undefined
}

export default SpaceDetailItem
